module.exports = __webpack_public_path__ + "static/media/family_17.aed31aa0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/family/JPEG/family_17.jpg
// module id = 5848
// module chunks = 0